/* eslint-disable import/no-extraneous-dependencies */
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates, import/no-namespace
import * as styled from 'styled-components/dist/styled-components.browser.esm.js';

/**
 * Intentionally (temporarily) keeping this console.log to help with debugging if a production issue arises again with styled-components
 */
// eslint-disable-next-line no-console
console.log(`>>>>>>>>>>> styled-components`, styled);

const _styled = 'default' in styled ? styled.default : styled;

// eslint-disable-next-line import/no-default-export
export default _styled;

// tslint:disable:ordered-imports
export {
  ServerStyleSheet,
  StyleSheetManager,
  ThemeConsumer,
  ThemeContext,
  ThemeProvider,
  createGlobalStyle,
  css,
  keyframes,
  // @ts-expect-error
  // eslint-disable-next-line import/no-duplicates
} from 'styled-components/dist/styled-components.browser.esm.js';

export type {
  DefaultTheme,
  FlattenSimpleInterpolation,
  StyledComponentPropsWithRef,
  ThemedStyledProps,
} from 'styled-components';
